import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';

@Injectable()
export class BudzetService {
  constructor(private http: HttpClient) {}

  getIzvestaj(payload: any): Observable<any> {
    return this.http.post(environment.mediaPlanApiUrl, payload);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/budzet.service.ts